// extracted by mini-css-extract-plugin
module.exports = {"container":"common_section-module__container--zUSTY"};